import type {
  BusinessAddressListType,
  ClientSettingsType,
  CustomerSupplierListType,
  SingleBatchDetailsDataType,
  StockItemQuantityRateType,
} from "@/redux/clientSettings/clientSettingTypes";

export const initialState: ClientSettingsType = {
  fetching: false,
  singleCustomerSupplierFetching: false,
  error: null,
  success: null,
  statusCode: null,
  ledgerMessage: null,
  customerSupplierMessage: null,
  skuMessage: null,
  uniqueSkuFetching: false,
  uniqueLedgerFetching: false,
  uniqueLegalNameFetching: false,
  uniqueLegalNameMessage: null,
  customerSupplierList: [],
  singleCustomerSupplier: {} as CustomerSupplierListType,
  customerSupplierListTotal: "",
  businessAddressList: [],
  singleBusinessAddressList: [],
  allLedgersList: [],
  allLedgersListTotal: "",
  allShowLedgersList: [],
  allTypesLedgersList: [],
  allExpensesLedgersList: [],
  allIncomeLedgersList: [],
  singleTypeLedgerList: [],
  allTypesLedgersWithTaxList: [],
  allUnitsMeasurement: [],
  allStockItemList: [],
  singleBusinessAddressData: {} as BusinessAddressListType,
  singleCustomerSupplierData: {} as CustomerSupplierListType,
  groupStockList: [],
  groupStockListTotal: "",
  stockItemListTotal: 0,
  unitsMeasurementListTotal: 0,
  groupParentStockList: [],
  departmentTotalCount: 0,
  departmentList: [],
  message: null,
  departmentUniqueCheckFetching: false,
  departmentUniqueCheckMessage: null,
  singleStockItemData: [],
  multipleStockItemQuantityData: [],
  mappedPdfTemplate: [],
  multipleFileUploadData: [],
  multipleFileUploadFetching: false,
  multipleFileUploadSuccess: null,
  multipleFileUploadError: null,
  stockItemBulkUploadData: {},
  clientMappedHSNData: {},
  warningSuccess: null,
  warningError: null,
  warningMessage: null,
  customerSupplierBulkUploadData: {},
  batchManagementList: [],
  singlebatchDetailsData: {} as SingleBatchDetailsDataType,
  batchNumberFetching: false,
  batchNumberUniqueMessage: null,
  batchManagementListTotalCount: 0,
  autoUniqueNumberGenerationData: {},
  alternateQuantitySettingsData: {},
  mappedStockBatchList: [],
  mappedStockBatchListTotalCount: 0,
  customerSupplierGroupingList: [],
  customerSupplierGroupingTotalCount: 0,
  documentTypeListing: [],
  uniqueGstNumberFetching: false,
  uniqueGstNumberMessage: null,
};
